import { getPermissionsForModule, Scopes } from 'src/app/scopes/scopes';
import { Create, Dashboard, Terminals, Update, Info } from './Children';

export const RecognitionConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      id: 'recognitionGroup',
      path: 'recognition',
      scopes: getPermissionsForModule('Recognition'),
      children: [
        {
          scopes: [Scopes.Recognition.show],
          id: 'recognitionGroup.dashboard',
          path: 'dashboard',
          element: <Dashboard />,
        },
        {
          scopes: [Scopes.Recognition.show],
          id: 'recognitionGroup.terminals',
          path: '',
          element: <Terminals />,
        },
        {
          scopes: [Scopes.Recognition.store],
          id: 'recognitionGroup.create',
          path: 'create',
          element: <Create />,
        },
        {
          scopes: [Scopes.Recognition.update],
          id: 'recognitionGroup.update',
          path: 'update',
          element: <Update />,
        },
        {
          scopes: [Scopes.Company.show],
          id: 'recognitionGroup.info',
          path: 'info',
          element: <Info />,
        },
      ],
    },
  ],
};
